module.exports = __webpack_public_path__ + "static/img/未标题-13.2f2c0ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/套装/未标题-13.png
// module id = 02u8
// module chunks = 0